import React from 'react';
import classNames from 'classnames';
import { AreaIcon, BarsIcon, LineIcon } from 'components/icons';
import { RadioButtonGroup, RadioButton } from 'components/shared/RadioButtonGroup';
import styles from './KPIFormatSelect.module.css';

function KPIFormatSelect({ value, onChange }) {
  return (
    <RadioButtonGroup value={value} onChange={onChange}>
      <RadioButton value="bar" className={classNames(styles.radio, { [styles.selected]: value === 'bar' })}>
        <BarsIcon />
      </RadioButton>
      <RadioButton value="line" className={classNames(styles.radio, { [styles.selected]: value === 'line' })}>
        <LineIcon />
      </RadioButton>
      <RadioButton value="area" className={classNames(styles.radio, { [styles.selected]: value === 'area' })}>
        <AreaIcon />
      </RadioButton>
    </RadioButtonGroup>
  );
}

export default KPIFormatSelect;
